import { render, staticRenderFns } from "./ToolDieMachineEdit.vue?vue&type=template&id=506c3654&"
import script from "./ToolDieMachineEdit.vue?vue&type=script&lang=js&"
export * from "./ToolDieMachineEdit.vue?vue&type=script&lang=js&"
import style0 from "./ToolDieMachineEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports